import TextField, { TextFieldProps } from '@mui/material/TextField';
import { SxProps, Theme } from '@mui/material/styles';
import React from 'react';

type AppTextFieldProps = TextFieldProps & {
  maxWidthSx?: SxProps<Theme>;
};

const defaultMaxWidth: SxProps<Theme> = { xs: '100%', sm: 'none' };

function AppTextField({
  size,
  fullWidth,
  sx,
  maxWidthSx = defaultMaxWidth,
  ...rest
}: AppTextFieldProps) {
  const sxList = Array.isArray(sx) ? sx : sx ? [sx] : [];
  const slotProps = {
    ...rest.slotProps,
    inputLabel: {
      shrink: true,
      ...(rest.slotProps?.inputLabel ?? {}),
    },
  };

  return (
    <TextField
      {...rest}
      slotProps={slotProps}
      size={size ?? 'small'}
      fullWidth={fullWidth ?? true}
      sx={[{ maxWidth: maxWidthSx }, ...sxList]}
    />
  );
}

export default AppTextField;
